/**
 * Metadata generation for PreProcessJson loader
 * Handles building template hierarchies, classifying keys, and resolving JSON inheritance
 * Port of csharp/AssemblerJson/Loader/PreProcessJson/GeneratePreProcessJsonMetadata.cs
 */

// Re-export from split modules
export { buildAppsiteHierarchy } from './generatePreProcessJsonMetadata_Hierarchy.js';
export { getTemplate } from './generatePreProcessJsonMetadata_Template.js';
export { classifyJsonKeys, classifyPlaceholdersRecursive } from './generatePreProcessJsonMetadata_Classification.js';
export { collectMissingMetaInfo } from './generatePreProcessJsonMetadata_MissingInfo.js';
export { isJsonKeyDuplicate, isPlaceholderDuplicate, isSlotholderDuplicate } from './generatePreProcessJsonMetadata_DuplicateChecks.js';

// Import functions for GeneratePreProcessJsonMetadata object
import { buildAppsiteHierarchy } from './generatePreProcessJsonMetadata_Hierarchy.js';
import { classifyJsonKeys, classifyPlaceholdersRecursive } from './generatePreProcessJsonMetadata_Classification.js';
import { collectMissingMetaInfo } from './generatePreProcessJsonMetadata_MissingInfo.js';

export const GeneratePreProcessJsonMetadata = {
    buildAppsiteHierarchy,
    classifyPlaceholdersRecursive,
    classifyJsonKeys,
    collectMissingMetaInfo,
};
